import tinycolor from 'tinycolor2';

import View from 'girder/views/View';

import editElement from '../templates/dialogs/editElement.pug';
import 'girder/utilities/jquery/girderModal';
import {
    restRequest
} from 'girder/rest';
import AnnotationModel from 'girder_plugins/large_image/models/AnnotationModel';
import StyleModel from '../models/StyleModel';

/**
 * Create a modal dialog with fields to edit the properties of
 * an annotation element.
 */
var EditElement = View.extend({
    events: {
        'click .h-submit': 'getData',
        'submit form': 'getData'
    },

    initialize() {
        this.easyAnnotationEnabled = false;
        // Variable is used to add new group created to style model
        this.annotationStyle = [];
    },

    render() {
        this.$el.html(
            editElement({
                element: this.annotationElement.toJSON(),
                easyAnnotationEnabled: this.easyAnnotationEnabled
            })
        ).girderModal(this);
        this.$('.h-colorpicker').colorpicker();
        return this;
    },

    /**
     * Get all data from the form and set the attributes of the
     * attached ElementModel (triggering a change event).
     */
    getData(evt) {
        evt.preventDefault();

        var data = {};
        var validation = '';

        var label = this.$('#h-element-label').val();
        data.label = label ? {
            value: label
        } : {};
        var group = this.$('#h-group-name').val() || this.annotationElement.attributes.group;
        data.group = group && group !== 'default' ? group : undefined;

        var lineWidth = this.$('#h-element-line-width').val();
        if (lineWidth) {
            data.lineWidth = parseFloat(lineWidth);
            if (data.lineWidth < 0 || !isFinite(data.lineWidth)) {
                validation += 'Invalid line width. ';
                this.$('#h-element-line-width').parent().addClass('has-error');
            }
        }

        var lineColor = this.$('#h-element-line-color').val();
        if (lineColor) {
            data.lineColor = this.convertColor(lineColor);
        }

        var fillColor = this.$('#h-element-fill-color').val();
        if (fillColor) {
            data.fillColor = this.convertColor(fillColor);
        }

        if (validation) {
            this.$('.g-validation-failed-message').text(validation)
                .removeClass('hidden');
            return;
        }
        // To check if the group name is changed
        if (this.annotationElement.attributes.group == group) {
            this.annotationElement.set(data);
        } else {
            this.selectedAnnotation = JSON.parse(JSON.stringify(this.annotation));
            // To check if any annotations are present in the group and delete set if there are no annotations associated after moving
            if (this.collection.length <= 1) {
                this.annotationSelector.deleteAnnotation(undefined, this.annotation.id);
                this.selectedAnnotation = {};
            } else {
                this.collection.remove(this.annotationElement.id);
            }
            // To get all annotation set with details based on image Id
            restRequest({
                url: `/annotation/item/${this.imageId}`,
                method: `GET`
            }).then((response) => {
                this.annotationSetData = response;
                let annData = this.annotation.attributes.annotation;
                let annotationSet = {};
                if (group == 'default') {
                    this.annotation.attributes.group = null;
                    this.annotationStyle["group"] = "default";
                    this.annotationStyle["id"] = "default";
                } else {
                    this.annotation.attributes.group = group;
                    this.annotationElement.attributes["group"] = group;
                    this.annotationStyle["group"] = this.annotationElement.attributes.group;
                    this.annotationStyle["id"] = this.annotationElement.attributes.group;
                }
                if (label) {
                    this.annotationElement.attributes["label"] = {
                        value: label
                    };
                    this.annotationStyle["label"] = {
                        value: label
                    };
                } else if (this.annotationElement.attributes["label"] && !this.annotationElement.attributes["label"]["value"]) {
                    delete this.annotationElement.attributes["label"]
                }
                this.annotationElement.attributes.lineWidth = data.lineWidth || 2;
                this.annotationElement.attributes.lineColor = data.lineColor;
                this.annotationElement.attributes.fillColor = data.fillColor;
                this.annotationStyle["lineWidth"] = this.annotationElement.attributes.lineWidth;
                this.annotationStyle["lineColor"] = this.annotationElement.attributes.lineColor;
                this.annotationStyle["fillColor"] = this.annotationElement.attributes.fillColor;
                // To check if the new group is in style model and add/update to it
                if (this.annotationSelector._groups.has(this.annotationStyle.id)) {
                    this.annotationSelector._groups.get(this.annotationStyle.id).set(this.annotationStyle).save()
                } else {
                    this.annotationStyles = new StyleModel(this.annotationStyle);
                    this.annotationSelector._groups.add(this.annotationStyles.toJSON());
                    this.annotationSelector._groups.get(this.annotationStyles.id).save();
                    this.contextMenu.refetchStyles();
                }
                // To check if there is annotation set already present with same name in the new group
                annotationSet = this.annotationSetData.find(a => (a.annotation.name == annData.name) && a.groups.indexOf(group) >= 0);
                if (group == null) {
                    delete this.annotation.attributes["group"]
                }
                if (annotationSet) {
                    annotationSet.annotation.elements.push(this.annotationElement.attributes);
                    restRequest({
                        url: `/annotation/${annotationSet._id}`,
                        contentType: 'application/json',
                        data: JSON.stringify(annotationSet.annotation),
                        method: 'PUT'
                    }).then((result) => {
                        //To fetch annotation sets and show transferred annotations in viewer. 
                        //transferredAnnotationSet => The annotation set that annotations are transferred
                        //selectedAnnotationSet => The annotatio set for which the annotation is selected to transfer
                        //If annotations are transferred from "Mets" to "Test", then Mets is selectedAnnotationSet and Test is transferredAnnotationSet
                        var transferredAnnotationSet = this.annotationSelector.collection.get(annotationSet._id);
                        this.annotationSelector.getUpdatedAnnotations(transferredAnnotationSet);
                        if (Object.keys(this.selectedAnnotation).length === 0 && this.selectedAnnotation.constructor === Object) {
                            //To show the annotation in the draw widget that is moved
                            this.annotationSelector.editAnnotation(this.annotationSelector.collection.get(annotationSet._id), false);
                            // To toggle the group of the annotation set updated in annotation selector widget
                            if (!this.annotationSelector._expandedGroups.has(annotationSet.groups[0])) {
                                if (annotationSet.groups[0] != null) {
                                    this.annotationSelector._expandedGroups.add(annotationSet.groups[0]);
                                } else {
                                    this.annotationSelector._expandedGroups.add("default");
                                }
                            }
                        } else {
                            this.annotationSelector.editAnnotation(this.annotationSelector.collection.get(this.selectedAnnotation._id), false);
                            if (!this.annotationSelector._expandedGroups.has(this.selectedAnnotation.groups[0])) {
                                if (this.selectedAnnotation.groups[0] != null) {
                                    this.annotationSelector._expandedGroups.add(this.selectedAnnotation.groups[0]);
                                } else {
                                    this.annotationSelector._expandedGroups.add("default");
                                }
                            }
                        }
                    });
                } else {
                    annData.elements = [];
                    // Create new annotation set
                    var model = new AnnotationModel({
                        itemId: this.imageId,
                        annotation: {}
                    });
                    _.extend(model.get('annotation'), {
                        name: annData.name
                    });
                    _.extend(model.attributes, {
                        groupName: group
                    })
                    model.save().done(() => {
                        this.annotationSelector.collection.add(model);
                        annData.elements.push(this.annotationElement.attributes);
                        restRequest({
                            url: `/annotation/${model.attributes._id}`,
                            contentType: 'application/json',
                            data: JSON.stringify(annData),
                            method: 'PUT'
                        }).then((result) => {
                            var transferredAnnotationSet = this.annotationSelector.collection.get(model.attributes._id);
                            this.annotationSelector.getUpdatedAnnotations(transferredAnnotationSet);
                            if (Object.keys(this.selectedAnnotation).length === 0 && this.selectedAnnotation.constructor === Object) {
                                this.annotationSelector.editAnnotation(this.annotationSelector.collection.get(model.attributes._id), false);
                                if (model.attributes.groupName != null) {
                                    this.annotationSelector._expandedGroups.add(model.attributes.groupName);
                                } else {
                                    this.annotationSelector._expandedGroups.add("default");
                                }
                            } else {
                                this.annotationSelector.editAnnotation(this.annotationSelector.collection.get(this.selectedAnnotation._id), false);
                                if (!this.annotationSelector._expandedGroups.has(this.selectedAnnotation.groups[0])) {
                                    if (this.selectedAnnotation.groups[0] != null) {
                                        this.annotationSelector._expandedGroups.add(this.selectedAnnotation.groups[0]);
                                    } else {
                                        this.annotationSelector._expandedGroups.add("default");
                                    }
                                }
                            }
                        });
                    });
                }
            });
        }

        this.$el.modal('hide');
    },

    /**
     * A helper function converting a string into normalized rgb/rgba
     * color value.  If no value is given, then it returns a color
     * with opacity 0.
     */
    convertColor(val) {
        if (!val) {
            return 'rgba(0,0,0,0)';
        }
        return tinycolor(val).toRgbString();
    }
});

/**
 * Create a singleton instance of this widget that will be rendered
 * when `show` is called.
 */
var dialog = new EditElement({
    parentView: null
});

/**
 * Show the edit dialog box.  Watch for change events on the passed
 * `ElementModel` to respond to user submission of the form.
 *
 * @param {ElementModel} annotationElement The element to edit
 * @returns {EditAnnotation} The dialog's view
 */
function show(annotationElement, easyAnnotationEnabled, collection, imageId, annotation, annotationSelector, contextMenu) {
    dialog.easyAnnotationEnabled = easyAnnotationEnabled;
    dialog.annotationElement = annotationElement;
    dialog.collection = collection;
    dialog.imageId = imageId;
    dialog.annotation = annotation;
    dialog.annotationSelector = annotationSelector;
    dialog.contextMenu = contextMenu;
    dialog.setElement('#g-dialog-container').render();
    return dialog;
}

export default show;



// WEBPACK FOOTER //
// ./plugins/HistomicsTK/web_client/dialogs/editElement.js